/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: network- edit-view-component
 *
 * Created by rwilliams on 7/24/17.
 */
'use strict';

function NetworkPropertiesEditViewController(
    _,
    $q,
    $routeParams,
    $route,
    $timeout,
    NetworkViewService,
    BreadcrumbService,
	CategoriesService,
	EnumService,
    MetadataService,
    MetadataEditService,
    RatingsService
) {
	var self = this;

	var getProps = function (properties) {
		var props = {};
		angular.forEach(properties, function (prop, name) {
			props[name] = prop;
		});
		return props;
	};

	var buildNetworkComponentsMap = function (network) {
		var allComponents = MetadataService.buildCustomComponentMap(network.metadata.properties);

		return getProps(allComponents);
	};

	var convertEnumPatternObjects = function () {
		self.network.breakPrePostRollPattern =
			_.find(self.availableBreakPatterns, {
			    id: self.network.breakPrePostRollPattern
            });
        self.network.ratingOverlayPattern =
            _.find(self.availableRatingOverlayPatterns, {
                id: self.network.ratingOverlayPattern
            });
	};

	var getData = function () {
		BreadcrumbService.editService = NetworkViewService;

		self.loadingIndicator.show = true;
		self.breadcrumb = {
			location: '/meta/networks/search',
			name: 'Networks',
			params: null
		};

		if (BreadcrumbService.getBreadcrumbs().length < 2) {
			BreadcrumbService.addBreadcrumb(self.breadcrumb);
		}

		var networkPromise;
        if ($routeParams.id !== '-1') {
            networkPromise = NetworkViewService.getEditViewData({id: $routeParams.id}).then(function (data) {
                self.network = NetworkViewService.network = data;
                return data;
            });
        } else {
            self.breadcrumbName = 'New Network';
            self.metadataProperties = [];
            networkPromise = $q.when(self.network);
        }

        return $q.all({
            enums: EnumService.queryForEnums(),
            network: networkPromise,
            packageCategories: CategoriesService.getAllCategories(),
            properties: MetadataEditService.getMetadataByGroup('Network'),
            ratingSystems: RatingsService.getRatingSystems()
        }).then(function (data) {
			var networkComponentsMap = {};

            self.availableBreakPatterns = EnumService.getEnumPicklist('Network_breakPrePostRollPattern');
            self.availableRatingOverlayPatterns = EnumService.getEnumPicklist('Network_ratingOverlayPattern');
            self.availableRatingSystems = _.values(data.ratingSystems);
            self.availablePackageCategories = data.packageCategories;
			self.metadataProperties = data.properties;

			if (self.network.metadata) {
				networkComponentsMap = buildNetworkComponentsMap(self.network);
			} else {
				var metadataItems = self.metadataProperties.reduce(function (mappedItems, metadataItem) {
					mappedItems[metadataItem.name] = {required: false, valueOverridden: false};
					return mappedItems;
				}, {});

				networkComponentsMap = MetadataService.buildCustomComponentMap(metadataItems);
			}

			NetworkViewService.networkComponentsMap(networkComponentsMap);
            convertEnumPatternObjects();
            self.loadingIndicator.show = false;
		});
	};

	var getPermissions = function () {
		NetworkViewService.getViewPermissions(NetworkViewService.permissionViewStates.NETWORK_VIEW_STATE).then(function (permissions) {
			self.permissions = permissions;
			self.canWrite = self.permissions.write;
			getData();
		});
	};

	var saveEditData = function () {
		self.loadingIndicator.show = true;

		if (typeof self.network.breakPrePostRollPattern === 'object') {
			self.network.breakPrePostRollPattern = self.network.breakPrePostRollPattern.id;
		}
        if (typeof self.network.ratingOverlayPattern === 'object') {
            self.network.ratingOverlayPattern = self.network.ratingOverlayPattern.id;
        }

		if (!self.network.metadata) {
			self.network.metadata = {
				properties: {}
			};
		}

		angular.forEach(NetworkViewService.networkComponentsMap(), function (comp, name) {
			var instanceValue = comp.instanceData.value;

			if (instanceValue) {
				if (self.network.metadata.properties[name]) {
					self.network.metadata.properties[name].value = instanceValue;
				} else {
					self.network.metadata.properties[name] = {
						value: instanceValue
					};
				}
			}
		});
		NetworkViewService
		.saveNetwork(self.network)
		.then(function (data) {
			self.breadcrumbName = self.network.name;
			self.network = data;
			convertEnumPatternObjects();
			NetworkViewService.originalNetworkData = _.cloneDeep(data);
			self.loadingIndicator.show = false;
			$route.updateParams({id: self.network.id});
			self.editorForm.$pristine = true;
			self.editorForm.$setPristine();
		});
	};

	self.$onInit = function () {
		if (self.isAdmin) {
			self.canWrite = true;
			getData();
		} else {
			getPermissions();
		}
	};

	self.$postLink = function () {
		$timeout(function () {
			NetworkViewService.editorForm = self.editorForm;
		});
	};

	self.$onDestroy = function () {
		NetworkViewService.network = null;
		self.metadataProperties = [];
	};

	self.network = {};

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};

	self.getNetworkComponentsMap = function () {
		return NetworkViewService.networkComponentsMap();
	};

	self.toolbarButtonDefs = [
		{
			label: 'Save',
			enabled: function () {
				var isNotPristine = self.editorForm && !self.editorForm.$pristine;
				var requiredFieldsSpecified = !!_.get(self.network, 'name') &&
                    !!_.get(self.network, 'value');

				return isNotPristine && requiredFieldsSpecified && self.canWrite;
			},
			onClick: saveEditData
		},
		{
			label: 'Revert',
			enabled: function () {
				var isNew = $routeParams.id < 0;
				var isNotPristine = self.editorForm && !self.editorForm.$pristine;

				return self.canWrite && (isNew || isNotPristine);
			},
			onClick: function () {
				self.network = NetworkViewService.revertEditData();
				convertEnumPatternObjects();
				self.editorForm.$pristine = true;
				self.editorForm.$setPristine();
			}
		},
		{
			label: 'Close',
			enabled: function () {
				return true;
			},
			onClick: NetworkViewService.exitEdit
		}
	];
}

angular.module('prism-ui.network').component('networkPropertiesEditView', {
	templateUrl: 'meta/network/editor/components/properties/network-properties-edit-view-template.html',
	controller: NetworkPropertiesEditViewController,
	bindings: {
		isAdmin: '<'
	}
});
